import { render, staticRenderFns } from "./LoanPlugin.vue?vue&type=template&id=320d00be&scoped=true&"
import script from "./LoanPlugin.vue?vue&type=script&lang=ts&"
export * from "./LoanPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d00be",
  null
  
)

export default component.exports